
import React from 'react'
import { useNavigate } from 'react-router-dom'
import { ArrowLeft } from 'lucide-react'

type Props={
    title:string  
    isDetail?:boolean
    rightContent?: React.ReactNode
    onBack?: () => void
}

const PageHeader:React.FC<Props>= ({title, isDetail, rightContent, onBack}) => {
  const navigate = useNavigate();
  
  const handleBack = () => {
    if (onBack) {
      onBack()
    } else {
      navigate(-1)
    }
  }
  
  return (
    <div className='h-16 flex gap-1 pl-2 pr-2 items-center justify-between sticky top-0 z-10 bg-white w-full border-b border-gray-200'>
      <div className='flex items-center gap-1'>
        {isDetail &&<button onClick={handleBack}><ArrowLeft /></button>}
        <h1 className='p-2 text-xl capitalize'>
          {title}
        </h1>
      </div>
      {rightContent && <div className='flex items-center'>{rightContent}</div>}
    </div>
  )
}

export default PageHeader
